import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  ViewEncapsulation,
} from "@angular/core";
import { GeneralSettingsService } from "../general-settings.service";
import { AdminApi, DonationCategory, LoopBackConfig } from "@lbsdk/*";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { FormGroup } from "@angular/forms";
import { MatDialog, MatSnackBar } from "@angular/material";
import { DonationCategoryFormComponent } from "./donation-category-form/donation-category-form.component";
import { ConfirmationDialogComponent } from "@app/main/content/confirmation-dialog/confirmation-dialog.component";
import { FuseSplashScreenService } from "@fuse/services/splash-screen.service";
import { OrganizationsDialogComponent } from "./organizations-dialog/organizations-dialog.component";
import { environment } from "@env/environment";

@Component({
  selector: "dontation-categories",
  templateUrl: "./dontation-categories.component.html",
  styleUrls: ["./dontation-categories.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DontationCategoriesComponent implements AfterViewInit, OnDestroy {
  donationCategories: DonationCategory[] = [];
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  page = 1;
  donationBreakpoint: number = 6;

  fileNameDialogRef: any;

  categoriesUploadPath: string = "";

  s3BucketUrl: string = environment.s3BucketUrl;

  /**
   *
   * @param generalSettingsService
   */
  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    private generalSettingsService: GeneralSettingsService,
    private fuseSplashScreenService: FuseSplashScreenService,
    private generalSettingService: GeneralSettingsService
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  /**
   * Life cycle methods
   */

  ngAfterViewInit(): void {
    this.categoriesUploadPath =
      environment.mainContainer + "/" + environment.categories;
    // Subscribe to update categories on changes
    this.generalSettingsService.onDonationCategoriesChanged
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((donationCategories: any[]) => {
        this.donationCategories = donationCategories;
        this.cdRef.detectChanges();
      });
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  /**
   * Public Methods
   */

  addDonationCategory() {
    this.fileNameDialogRef = this.dialog.open(DonationCategoryFormComponent, {
      panelClass: "donation-category-form-dialog",
      data: {
        action: "new",
      },
    });

    this.fileNameDialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((response: FormGroup) => {
        if (!response) {
          return;
        }
        this.fuseSplashScreenService.show();
        const data = {
          name: response.value.name.toLowerCase(),
          image: response.value.image,
        };
        this.createDonationCategory(data);
      });
  }

  openOrganizationDialog(donationCategoryId) {
    this.fileNameDialogRef = this.dialog.open(OrganizationsDialogComponent, {
      panelClass: "oraganizaton-dialog",
      data: {
        action: "new",
        donationCategoryId: donationCategoryId,
      },
    });
  }

  createDonationCategory = async (data) => {
    const file = data.image._files[0];

    const formData = new FormData();
    formData.append("file", file);

    const url: string =
      LoopBackConfig.getPath() +
      "/" +
      LoopBackConfig.getApiVersion() +
      "/containers/" +
      encodeURIComponent(this.categoriesUploadPath) +
      "/upload";

    try {
      const uploadCategoryImageResponse: any = await this.generalSettingService
        .uploadCategoryImage(url, formData)
        .toPromise();

      if (!uploadCategoryImageResponse) return;

      data.image =
        uploadCategoryImageResponse.result.files["file"][0][
          "providerResponse"
        ].name;

      const createDonationCategoryResponse = await this.generalSettingsService
        .createDonationCategory(data)
        .toPromise();
      this.fuseSplashScreenService.hide();
      if (!createDonationCategoryResponse) return;

      this.donationCategories.push(createDonationCategoryResponse);
      this.snackBar.open("Donation category created successfully", "OK", {
        verticalPosition: "top",
        duration: 2000,
      });
    } catch (error) {
      this.fuseSplashScreenService.hide();
      this.snackBar.open("Problem creating donation category", "ERROR", {
        verticalPosition: "top",
        duration: 2000,
      });
      return error;
    }
  };

  onResize(event) {
    this.donationBreakpoint = this.generalSettingsService.onResize(event);
  }

  donationDelete(donationId) {
    this.fileNameDialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: "Are you sure you want to Delete?",
      },
    });
    this.fileNameDialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(async (result) => {
        if (!result) return;
        this.fuseSplashScreenService.show();
        try {
          const deleteResponse = await this.generalSettingsService
            .deleteDonationCategoryById(donationId)
            .toPromise();
          this.fuseSplashScreenService.hide();
          if (!deleteResponse) return;

          this.snackBar.open("Donation category deleted successfully", "OK", {
            verticalPosition: "top",
            duration: 2000,
          });
        } catch (error) {
          this.fuseSplashScreenService.hide();
          this.snackBar.open("Problem deleting donation category", "ERROR", {
            verticalPosition: "top",
            duration: 2000,
          });
          return error;
        }
      });
  }
}
